import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import NytMedlem from '../views/NytMedlem.vue'
import MedlemsListe from '../views/MedlemsListe.vue'
import MedlemResult from '../views/MedlemResult.vue'
import AdminLogin from '../views/AdminLogin.vue'
import MedlemsData from '../views/MedlemsData.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/nyt-medlem',
    name: 'Nyt Medlem',
    component: NytMedlem
  },
  {
    path: '/medlemsliste',
    name: 'Medlemsliste',
    component: MedlemsListe
  },
  {
    path: '/medlem-resultat',
    name: 'MedlemResult',
    component: MedlemResult
  },
  {
    path: '/admin-login',
    name: 'AdminLogin',
    component: AdminLogin
  },
  {
    path: '/medlemsdata/:id',
    name: 'MedlemsData',
    component: MedlemsData,
    props: true
  }
]

const router = new VueRouter({
  routes
})

export default router
